module.exports = __webpack_public_path__ + "static/media/2.f2e1f8d0.png";